<template>
	<v-form ref="form" v-model="formIsValid" lazy-validation>
		<modal
			:exibir="exibir"
			:titulo="'Editar Modelo de Documento'"
			:max-width="450"
			:is-confirmar-visivel="true"
			:custom-actions="false"
			:acao-cancelar="fecharModal"
			:acao-confirmar="confirmar"
			nome-botao-confirmar="Salvar"
			:is-confirmar-desabilitado="!formIsValid"
			@close="fecharModal"
		>
			<template #body>
				<v-row class="mt-1 mb-2">
					<v-col cols="12">
						<label-personalizado nome-campo="Tipo" obrigatorio-por-padrao class="mb-2">
						</label-personalizado>
						<span>{{ modeloDocumento.nomeTipoDocumento }}</span>
					</v-col>
					<v-col cols="12">
						<label-personalizado
							nome-campo="Titulo"
							obrigatorio-por-padrao
							class="mb-2"
						></label-personalizado>
						<v-text-field
							v-model="modeloDocumento.nome"
							id="editar-modelo-titulo"
							placeholder="Informe"
							type="string"
							clearable
							counter="100"
							:rules="regrasTituloDocumentoModelo"
							class="pt-0"
						>
						</v-text-field>
					</v-col>
					<v-col id="situacaoModelo" cols="12">
						<label-personalizado nome-campo="Situação" :obrigatorioPorPadrao="true"></label-personalizado>
						<v-radio-group
							v-model="modeloDocumento.situacao"
							v-validate="'required'"
							row
							class="az-checkbox"
							name="Situação"
							:error-messages="errors.collect('Situação')"
							mandatory
						>
							<v-radio
								v-for="situacao in getSituacoes"
								:key="situacao.value"
								:label="situacao.text"
								:value="situacao.value"
							></v-radio>
						</v-radio-group>
					</v-col>
				</v-row>
			</template>
		</modal>
	</v-form>
</template>
<script>
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'
import { actionTypes, mutationTypes, situacoes } from '@/core/constants/index'
import validacaoFormulario from '@/views/mixins/validacaoFormulario'
import { mapState } from 'vuex'

export default {
	name: 'editar-modelo-documento',
	components: { LabelPersonalizado },
	mixins: [validacaoFormulario],
	props: {
		exibir: {
			type: Boolean,
		},
	},
	data() {
		return {
			formIsValid: false,
			regrasTituloDocumentoModelo: [
				(value) => this.regraObrigatoriedade(value, 'Campo obrigatório.'),
				(value) =>
					this.regraDeTamanhoMaximoString(
						value,
						100,
						'O campo de título deve ser igual ou menor do que 100 caracteres!',
					),
			],
		}
	},
	computed: {
		...mapState({
			modeloDocumento: (state) => state.configuracao.modeloDocumento.modeloEdicao,
		}),
		getSituacoes() {
			return Object.values(situacoes.MODELO_DOCUMENTO)
		},
	},
	beforeDestroy() {
		this.$store.commit(mutationTypes.CONFIGURACAO.MODELO_DOCUMENTO.RESET_INFORMACOES_MODELO)
	},
	methods: {
		async confirmar() {
			if (this.$refs.form.validate()) {
				this.modeloDocumento.idModeloDocumento = this.modeloDocumento.id
				await this.$store.dispatch(
					actionTypes.CONFIGURACAO.MODELO_DOCUMENTO.EDITAR_MODELO,
					this.modeloDocumento,
				)

				this.mostrarNotificacaoSucesso('Alteração realizada com sucesso')
				this.fecharModal()
				this.recarregarListagemExterna()
			}
		},
		fecharModal() {
			this.$emit('fechar-modal')
		},
		recarregarListagemExterna() {
			this.$emit('resetar-page')
		},
	},
}
</script>
